export default {
  'zh_CN': {
    'travel.car-records.id.label': '主键',
    'travel.car-records.id.holder': '请输入主键',

    'travel.car-records.id.required': '主键必填',
    'travel.car-records.dataId.label': '数据id',
    'travel.car-records.dataId.holder': '请输入数据id',

    'travel.car-records.dataId.required': '数据id必填',
    'travel.car-records.plateNo.label': '车牌号',
    'travel.car-records.plateNo.holder': '请输入车牌号',
    'travel.car-records.plateNo.max': '车牌号最多10个字符',

    'travel.car-records.plateNo.required': '车牌号必填',
    'travel.car-records.plateColor.label': '车牌颜色',
    'travel.car-records.plateColor.holder': '请输入车牌颜色',

    'travel.car-records.plateColor.required': '车牌颜色必填',
    'travel.car-records.crossType.label': '进出类型',
    'travel.car-records.crossType.holder': '请输入进出类型',

    'travel.car-records.crossType.dictionary': () => [{ value: 0, label: '进场' }, { value: 1, label: '出场' }],
    'travel.car-records.crossType.required': '进出类型必填',
    'travel.car-records.gate.label': '闸口编号',
    'travel.car-records.gate.holder': '请输入闸口编号',
    'travel.car-records.gate.max': '闸口编号最多10个字符',

    'travel.car-records.gate.required': '闸口编号必填',
    'travel.car-records.channel.label': '通道编号',
    'travel.car-records.channel.holder': '请输入通道编号',
    'travel.car-records.channel.max': '通道编号最多10个字符',

    'travel.car-records.channel.required': '通道编号必填',
    'travel.car-records.crossTime.label': '通过时间',
    'travel.car-records.crossTime.holder': '请输入通过时间',
    'travel.car-records.crossTime.required': '通过时间必填',
    'travel.car-records.releaseReason.label': '放行原因',
    'travel.car-records.releaseReason.holder': '请输入放行原因',

    'travel.car-records.releaseReason.dictionary': () => [{ value: 101, label: '临时车自动放行' }, {
      value: 102,
      label: '预约车自动放行'
    }, { value: 100, label: 'vip自动放行' }],
    'travel.car-records.releaseReason.required': '放行原因必填',
    'travel.car-records.releaseWay.label': '放行方式',
    'travel.car-records.releaseWay.holder': '请输入放行方式',

    'travel.car-records.releaseWay.dictionary': () => [{ value: 11, label: '自动开闸' }, {
      value: 12,
      label: '人工人工开闸'
    }, { value: 13, label: '遥控器开闸' }, { value: 10, label: '未开闸' }],
    'travel.car-records.releaseWay.required': '放行方式必填',
    'travel.car-records.releaseResult.label': '放行结果',
    'travel.car-records.releaseResult.holder': '请输入放行结果',

    'travel.car-records.releaseResult.dictionary': () => [{ value: 0, label: '未放行' }, {
      value: 1,
      label: '正常放行'
    }, { value: 2, label: '离线放行' }],
    'travel.car-records.releaseResult.required': '放行结果必填',
    'travel.car-records.plateImg.label': '车辆图片',
    'travel.car-records.plateImg.holder': '请输入车辆图片',
    'travel.car-records.plateImg.max': '车辆图片最多255个字符',

    'travel.car-records.plateImg.required': '车辆图片必填',
    'travel.car-records.boxNum.label': '箱数',
    'travel.car-records.boxNum.holder': '请输入箱数',

    'travel.car-records.boxNum.required': '箱数必填',
    'travel.car-records.box.label': '箱号',
    'travel.car-records.box.holder': '请输入箱号',
    'travel.car-records.box.max': '箱号最多20个字符',

    'travel.car-records.box.required': '箱号必填',
    'travel.car-records.boxIso.label': '国际标准',
    'travel.car-records.boxIso.holder': '请输入国际标准',
    'travel.car-records.boxIso.max': '国际标准最多20个字符',

    'travel.car-records.boxIso.required': '国际标准必填',
    'travel.car-records.boxImg.label': 'boxImg',
    'travel.car-records.boxImg.holder': '请输入boxImg',
    'travel.car-records.boxImg.max': 'boxImg最多65535个字符',

    'travel.car-records.boxImg.required': 'boxImg必填',
    'travel.car-records.remark.label': '备注',
    'travel.car-records.remark.holder': '请输入备注',
    'travel.car-records.remark.max': '备注最多100个字符',

    'travel.car-records.remark.required': '备注必填',
    'travel.car-records.createTime.label': '创建时间',
    'travel.car-records.createTime.holder': '请输入创建时间',
    'travel.car-records.createTime.required': '创建时间必填',
    'travel.car-records.updateTime.label': '更新时间',
    'travel.car-records.updateTime.holder': '请输入更新时间',
    'travel.car-records.updateTime.required': '更新时间必填',
    'travel.car-records.isDelete.label': '是否删除',
    'travel.car-records.isDelete.holder': '请输入是否删除',

    'travel.car-records.isDelete.dictionary': () => [{ value: 0, label: '删除' }],
    'travel.car-records.isDelete.required': '是否删除必填'
  },
  'zh_TW': {
    'travel.car-records.id.label': '主键',
    'travel.car-records.id.holder': '請輸入主键',

    'travel.car-records.id.required': '主键必填',
    'travel.car-records.dataId.label': '数据id',
    'travel.car-records.dataId.holder': '請輸入数据id',

    'travel.car-records.dataId.required': '数据id必填',
    'travel.car-records.plateNo.label': '车牌号',
    'travel.car-records.plateNo.holder': '請輸入车牌号',

    'travel.car-records.plateNo.required': '车牌号必填',
    'travel.car-records.plateColor.label': '车牌颜色',
    'travel.car-records.plateColor.holder': '請輸入车牌颜色',

    'travel.car-records.plateColor.required': '车牌颜色必填',
    'travel.car-records.crossType.label': '进出类型',
    'travel.car-records.crossType.holder': '請輸入进出类型',

    'travel.car-records.crossType.required': '进出类型必填',
    'travel.car-records.gate.label': '闸口编号',
    'travel.car-records.gate.holder': '請輸入闸口编号',

    'travel.car-records.gate.required': '闸口编号必填',
    'travel.car-records.channel.label': '通道编号',
    'travel.car-records.channel.holder': '請輸入通道编号',

    'travel.car-records.channel.required': '通道编号必填',
    'travel.car-records.crossTime.label': '通过时间',
    'travel.car-records.crossTime.holder': '請輸入通过时间',

    'travel.car-records.crossTime.required': '通过时间必填',
    'travel.car-records.releaseReason.label': '放行原因',
    'travel.car-records.releaseReason.holder': '請輸入放行原因',

    'travel.car-records.releaseReason.required': '放行原因必填',
    'travel.car-records.releaseWay.label': '放行方式',
    'travel.car-records.releaseWay.holder': '請輸入放行方式',

    'travel.car-records.releaseWay.required': '放行方式必填',
    'travel.car-records.releaseResult.label': '放行结果',
    'travel.car-records.releaseResult.holder': '請輸入放行结果',

    'travel.car-records.releaseResult.required': '放行结果必填',
    'travel.car-records.plateImg.label': '车辆图片',
    'travel.car-records.plateImg.holder': '請輸入车辆图片',

    'travel.car-records.plateImg.required': '车辆图片必填',
    'travel.car-records.boxNum.label': '箱数',
    'travel.car-records.boxNum.holder': '請輸入箱数',

    'travel.car-records.boxNum.required': '箱数必填',
    'travel.car-records.box.label': '箱号',
    'travel.car-records.box.holder': '請輸入箱号',

    'travel.car-records.box.required': '箱号必填',
    'travel.car-records.boxIso.label': '国际标准',
    'travel.car-records.boxIso.holder': '請輸入国际标准',

    'travel.car-records.boxIso.required': '国际标准必填',
    'travel.car-records.boxImg.label': 'boxImg',
    'travel.car-records.boxImg.holder': '請輸入boxImg',

    'travel.car-records.boxImg.required': 'boxImg必填',
    'travel.car-records.remark.label': '备注',
    'travel.car-records.remark.holder': '請輸入备注',

    'travel.car-records.remark.required': '备注必填',
    'travel.car-records.createTime.label': '创建时间',
    'travel.car-records.createTime.holder': '請輸入创建时间',

    'travel.car-records.createTime.required': '创建时间必填',
    'travel.car-records.updateTime.label': '更新时间',
    'travel.car-records.updateTime.holder': '請輸入更新时间',

    'travel.car-records.updateTime.required': '更新时间必填',
    'travel.car-records.isDelete.label': '是否删除',
    'travel.car-records.isDelete.holder': '請輸入是否删除',

    'travel.car-records.isDelete.required': '是否删除必填'
  },
  'en_US': {
    'travel.car-records.id.label': 'id',
    'travel.car-records.id.holder': 'Enter id',
    'travel.car-records.id.max': 'id max length: 主键',

    'travel.car-records.id.required': 'id required',
    'travel.car-records.dataId.label': 'dataId',
    'travel.car-records.dataId.holder': 'Enter dataId',
    'travel.car-records.dataId.max': 'dataId max length: 数据id',

    'travel.car-records.dataId.required': 'dataId required',
    'travel.car-records.plateNo.label': 'plateNo',
    'travel.car-records.plateNo.holder': 'Enter plateNo',
    'travel.car-records.plateNo.max': 'plateNo max length: 车牌号',

    'travel.car-records.plateNo.required': 'plateNo required',
    'travel.car-records.plateColor.label': 'plateColor',
    'travel.car-records.plateColor.holder': 'Enter plateColor',
    'travel.car-records.plateColor.max': 'plateColor max length: 车牌颜色',

    'travel.car-records.plateColor.required': 'plateColor required',
    'travel.car-records.crossType.label': 'crossType',
    'travel.car-records.crossType.holder': 'Enter crossType',
    'travel.car-records.crossType.max': 'crossType max length: 进出类型',

    'travel.car-records.crossType.required': 'crossType required',
    'travel.car-records.gate.label': 'gate',
    'travel.car-records.gate.holder': 'Enter gate',
    'travel.car-records.gate.max': 'gate max length: 闸口编号',

    'travel.car-records.gate.required': 'gate required',
    'travel.car-records.channel.label': 'channel',
    'travel.car-records.channel.holder': 'Enter channel',
    'travel.car-records.channel.max': 'channel max length: 通道编号',

    'travel.car-records.channel.required': 'channel required',
    'travel.car-records.crossTime.label': 'crossTime',
    'travel.car-records.crossTime.holder': 'Enter crossTime',
    'travel.car-records.crossTime.max': 'crossTime max length: 通过时间',

    'travel.car-records.crossTime.required': 'crossTime required',
    'travel.car-records.releaseReason.label': 'releaseReason',
    'travel.car-records.releaseReason.holder': 'Enter releaseReason',
    'travel.car-records.releaseReason.max': 'releaseReason max length: 放行原因',

    'travel.car-records.releaseReason.required': 'releaseReason required',
    'travel.car-records.releaseWay.label': 'releaseWay',
    'travel.car-records.releaseWay.holder': 'Enter releaseWay',
    'travel.car-records.releaseWay.max': 'releaseWay max length: 放行方式',

    'travel.car-records.releaseWay.required': 'releaseWay required',
    'travel.car-records.releaseResult.label': 'releaseResult',
    'travel.car-records.releaseResult.holder': 'Enter releaseResult',
    'travel.car-records.releaseResult.max': 'releaseResult max length: 放行结果',

    'travel.car-records.releaseResult.required': 'releaseResult required',
    'travel.car-records.plateImg.label': 'plateImg',
    'travel.car-records.plateImg.holder': 'Enter plateImg',
    'travel.car-records.plateImg.max': 'plateImg max length: 车辆图片',

    'travel.car-records.plateImg.required': 'plateImg required',
    'travel.car-records.boxNum.label': 'boxNum',
    'travel.car-records.boxNum.holder': 'Enter boxNum',
    'travel.car-records.boxNum.max': 'boxNum max length: 箱数',

    'travel.car-records.boxNum.required': 'boxNum required',
    'travel.car-records.box.label': 'box',
    'travel.car-records.box.holder': 'Enter box',
    'travel.car-records.box.max': 'box max length: 箱号',

    'travel.car-records.box.required': 'box required',
    'travel.car-records.boxIso.label': 'boxIso',
    'travel.car-records.boxIso.holder': 'Enter boxIso',
    'travel.car-records.boxIso.max': 'boxIso max length: 国际标准',

    'travel.car-records.boxIso.required': 'boxIso required',
    'travel.car-records.boxImg.label': 'boxImg',
    'travel.car-records.boxImg.holder': 'Enter boxImg',
    'travel.car-records.boxImg.max': 'boxImg max length: boxImg',

    'travel.car-records.boxImg.required': 'boxImg required',
    'travel.car-records.remark.label': 'remark',
    'travel.car-records.remark.holder': 'Enter remark',
    'travel.car-records.remark.max': 'remark max length: 备注',

    'travel.car-records.remark.required': 'remark required',
    'travel.car-records.createTime.label': 'createTime',
    'travel.car-records.createTime.holder': 'Enter createTime',
    'travel.car-records.createTime.max': 'createTime max length: 创建时间',

    'travel.car-records.createTime.required': 'createTime required',
    'travel.car-records.updateTime.label': 'updateTime',
    'travel.car-records.updateTime.holder': 'Enter updateTime',
    'travel.car-records.updateTime.max': 'updateTime max length: 更新时间',

    'travel.car-records.updateTime.required': 'updateTime required',
    'travel.car-records.isDelete.label': 'isDelete',
    'travel.car-records.isDelete.holder': 'Enter isDelete',
    'travel.car-records.isDelete.max': 'isDelete max length: 是否删除',

    'travel.car-records.isDelete.required': 'isDelete required'
  }
}
